<form [formGroup]="dataForm" class="without-default-focus">
    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Etape devant être complétée(s)</mat-label>
            <mat-select data-select-step formControlName="step" multiple required tabindex="10">
                @for (item of _steps; track item.id) {
                    <mat-option data-select-listing-type-option [value]="item.id">
                        {{ item.data.stepName }}
                    </mat-option>
                }
            </mat-select>
            @if (dataForm.errors && dataForm.errors['step']?.required && (dataForm.controls['step']?.dirty || dataForm.controls['step'].touched)) {
                <mat-error data-input-role-error>Au moins une étape doit être selectionnée.</mat-error>
            }
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Etape" matTooltipPosition="right"></fa-icon>
    </div>
</form>
